import { DummyTeacherSM } from "../service-models/v1/dummy-teacher-s-m";
import { BaseViewModel } from "./base.viewmodel";

export class DummyTeacherViewModel implements BaseViewModel {
    PageTitle: string = 'Dummy Teacher';
    AddEditModalTitle: string = '';
    teachers: DummyTeacherSM[] = [];
    singleTeacher!: DummyTeacherSM;

}